const CODIGO_REGEX = /^(?=.*[1-9])[0-9]{1,5}$/

export const validateCodigo = (value: string | undefined | null) => {
  if (!value) return true
  return CODIGO_REGEX.test(value)
}
